import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import ShowLoading from '../helperComponent/ShowLoading';
import subjectsImg from '../../assets/subjects.png';
import AddSubjectForm from './AddSubjectForm';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const SubjectPage = () => {
  const [subjects, setSubjects] = useState([]);
  const [addSubject, setAddSubject] = useState(false);
  const [buttonText, setButtonText] = useState('Add Subject');
  const uname = JSON.parse(localStorage.getItem('uname'));
  const [showLoading, setShowLoading] = useState(true);

  const fetchURL = `https://stucharge.bakersbrisk.com/api/subjectapi?username=${uname}`;
  const URL = 'https://stucharge.bakersbrisk.com/api/subjectapi';
  const AuthStr = process.env.REACT_APP_AUTH_STR;
  let history = useHistory();

  // fetch subjects
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response.status === 200) {
          localStorage.setItem('subjects', JSON.stringify(response.data));
          setSubjects(response.data);
          setShowLoading(false);
        } else if (response.status !== 200)
          toast.error('Something went wrong, please refresh');
      })
      .catch((error) => {
        if (error) console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addSubjects = (name) => {
    console.log(name);
    var bodyFormData = new FormData();
    bodyFormData.append('name', name);
    bodyFormData.append('username', uname);
    console.log(bodyFormData);
    // send subject data to server
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201)
          toast.success('Subject added successfully!');
        history.push('/home');
        history.push('/subjects');
      })
      .catch((error) => {
        toast.error('Something went wrong, please try again');
      });
  };

  // Onclick handler
  const onClickHandler = () => {
    setAddSubject(!addSubject);
    setButtonText(buttonText === 'Add Subject' ? 'Close' : 'Add Subject');
  };

  // Update handler
  const handleDelete = (key) => {
    const deleteUrl = `https://stucharge.bakersbrisk.com/api/subjectapi?username=${uname}&id=${key}`;
    Swal.fire({
      title: 'Are you sure? Data will be deleted permanantly',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteSection(deleteUrl);
      } else if (result.isDenied) {
        Swal.fire('Subject not deleted', '', 'info');
      }
    });
  };

  // making delete request
  const deleteSection = async (deleteURL) => {
    console.log(deleteURL);
    const res = await axios.delete(deleteURL, {
      headers: { Authorization: AuthStr },
    });
    if (res.status !== 200) {
      Swal.fire('Error deleting data!', '', 'error');
    } else {
      Swal.fire('Subject deleted!', '', 'success');
      history.push('/home');
      history.push('/subjects');
    }
  };

  // Update subject handler
  const handleUpdate = (key) => {
    Swal.fire({
      title: 'Edit Subject Name',
      html: `<input type="text" id="title" class="swal2-input" placeholder="Enter subject name">`,
      confirmButtonText: 'Confirm',
      focusConfirm: false,
      showDenyButton: true,
      denyButtonText: 'Cancel',
      preConfirm: () => {
        const title = Swal.getPopup().querySelector('#title').value;
        if (title === '') {
          Swal.fire('You need to write something', '', 'error');
        } else {
          var formData = new FormData();
          formData.append('name', title);
          updateSubject(formData, key);
        }
      },
    }).then((result) => {
      if (result.isDenied) {
        Swal.fire('Subject name not updated!', '', 'info');
      }
    });
  };

  async function updateSubject(bodyFormData, key) {
    const updateURL = `https://stucharge.bakersbrisk.com/api/subjectapi?username=${uname}&id=${key}`;
    const requestOptions = {
      method: 'PUT',
      headers: { Authorization: AuthStr },
      body: bodyFormData,
    };
    fetch(updateURL, requestOptions)
      .then(async (response) => {
        const data = await response.json();
        // check for error response
        if (!response.ok) {
          const error = (data && data.message) || response.status;
          return Promise.reject(error);
        }
        Swal.fire('Subject updated successfully!', '', 'success');
        history.push('/home');
        history.push('/subjects');
      })
      .catch((error) => {
        Swal.fire('Error updating data', '', 'error');
      });
  }

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={subjectsImg} alt='subjects' />
          <div className='main_greeting'>
            <h1>Subjects</h1>
            <p>Your subjects are visible here</p>
            {showLoading && <ShowLoading />}
          </div>
        </div>

        <div className='add-notes'>
          <button
            onClick={onClickHandler}
            style={{
              background: addSubject ? '#ef4f4f' : '#00b5c3',
            }}
          >
            {buttonText}
          </button>
        </div>

        {addSubject && <AddSubjectForm addSubjects={addSubjects} />}

        <div className='subjects-div'>
          {subjects.length > 0 ? (
            <>
              <div className='table-container'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Title</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subjects.map((item, index) => (
                      <tr key={item.id}>
                        <td data-label='#'>{index + 1}</td>
                        <td data-label='Title'>{item.name}</td>
                        <td data-label='Edit'>
                          <button
                            onClick={() => handleUpdate(item.id)}
                            className='bttn update'
                          >
                            Edit
                          </button>
                        </td>
                        <td data-label='Delete'>
                          <button
                            className='bttn delete'
                            onClick={() => handleDelete(item.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className='alert-heading'>
              <h1>No subjects added</h1>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default SubjectPage;
